module.exports = __webpack_public_path__ + "img/search.18c82894.svg";